import { render } from "./gsggDetail.vue?vue&type=template&id=33f072bd&scoped=true&ts=true"
import script from "./gsggDetail.vue?vue&type=script&lang=ts"
export * from "./gsggDetail.vue?vue&type=script&lang=ts"

import "./gsggDetail.vue?vue&type=style&index=0&id=33f072bd&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f072bd"]])

export default __exports__